import React from 'react'

const ReceivedPayment = () => {
  return (
    <div>ReceivedPayment</div>
  )
}

export default ReceivedPayment